import styled from 'styled-components';
import { Dialog, DialogTitle } from '@material-ui/core';
import { TextField } from 'formik-material-ui';

export const SDialog = styled(Dialog)`
  [role='dialog'] {
    padding: 1em;
  }
`;

export const SDialogTitle = styled(DialogTitle)`
  text-align: center;
`;

export const ActionButtonSection = styled.div`
  text-align: end;
`;

export const defaultFieldProps = {
  component: TextField,
  variant: 'outlined',
  fullWidth: true,
  style: { marginTop: '12px' },
};

export const defaultDateProps = {
  InputLabelProps: { shrink: true },
};
